export default function Hero() {
  return (
    <section className="relative z-10 mx-auto flex w-full max-w-7xl flex-col items-start px-6 pt-16 md:px-10 md:pt-24">
      <span className="mb-8 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-3 py-1 text-[11px] font-medium tracking-wider text-white/70 backdrop-blur-md">
        <span className="h-1.5 w-1.5 rounded-full bg-white/80" />
        SHADERS · v0.0.76
      </span>

      <h1
        className="max-w-4xl text-[52px] leading-[1.02] tracking-tight text-white md:text-[88px]"
        style={{ fontFamily: "'Instrument Serif', serif" }}
      >
        Motion,
        <br />
        <span style={{ fontStyle: "italic" }}>made&nbsp;tangible.</span>
      </h1>

      <p className="mt-6 max-w-md text-[14px] leading-relaxed text-white/55 md:text-[15px]">
        A living canvas of liquid metal. Drag it, push it, let it drift &mdash;
        the surface responds like matter, not pixels.
      </p>

      <div className="mt-10 flex flex-wrap items-center gap-3">
        <a
          href="#start"
          className="rounded-full bg-white px-5 py-3 text-[13px] font-medium text-black transition-transform hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
        >
          Start building
        </a>
        <a
          href="#explore"
          className="rounded-full border border-white/15 bg-white/[0.04] px-5 py-3 text-[13px] font-medium text-white backdrop-blur-md transition-colors hover:bg-white/10 cursor-pointer whitespace-nowrap"
        >
          Explore shaders
        </a>
      </div>
    </section>
  );
}